import SalesList from "../../../component/users/sales/SalesList";

function Sales() {
  return (
    <div className="page-body">
      <SalesList />
    </div>
  );
}

export default Sales;
